var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgAlert = props => /*#__PURE__*/React.createElement("svg", _extends({
  fill: "none",
  viewBox: "0 0 64 64"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "#ff456a",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 4,
  d: "M32 21.333V32m0 10.667h.026M24.274 5.333h15.451a8 8 0 0 1 5.659 2.344L56.32 18.611a8 8 0 0 1 2.346 5.666v15.45a8 8 0 0 1-2.344 5.66L45.39 56.323a8 8 0 0 1-5.661 2.346H24.274a8 8 0 0 1-5.658-2.346L7.68 45.389a8 8 0 0 1-2.347-5.664v-15.45a8 8 0 0 1 2.344-5.66L18.61 7.68a8 8 0 0 1 5.667-2.347z"
})));
export default SvgAlert;